export const NO_ACCOUNT_ID = 'no-account-id';
export const NO_BOARD_ID = 'no-board-id';
